export default __webpack_public_path__ + "static/media/adyasa_core.e802df1c.jpg";